import * as types from "./actionTypes";
import {INIT_INTERNET_CONNECTION_STATUS} from "./actionTypes";

export const get = () => {
  return {
    type: types.INIT_REQUEST
  };
};

export const getSuccess = (data, projectStatus = false) => {
  return {
    type: types.INIT_SUCCESS,
    payLoad: { data: data, loading: false, project_status: projectStatus }
  };
};

export const getFailure = (data, userNotVerified) => {
  if (data && data.data && data.data.project) {
    return {
      type: types.INIT_FAILURE,
      payLoad: { data: data, loading: false }
    };
  } else {
    return {
      type: types.INIT_FAILURE,
      payLoad: { loading: false, userNotVerified:userNotVerified }
    };
  }
};

export const sentHelpStatus =data =>{
  return{
    type:types.INIT_HELP_STATUS,
    payLoad:data
  }
};

export const changeServerInterruptStatus = (status = "") =>{
  return{
    type: INIT_INTERNET_CONNECTION_STATUS,
    payLoad:{serverInterruptStatus: status}
  }
};